// Single source of truth for the "new account" label — inferred from account
// age, never stored. Rationale and consumers: `.specs/users.md` → "Account
// labels".

/** Age below which an account is still "new". Retune here; nothing hard-codes a span. */
export const NEW_ACCOUNT_AGE_DAYS = 7;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export type AccountLabelInput = {
  createdAt: Date | string;
  /** Non-null once biometric + device attestation passed; outranks age. */
  verifiedHumanAt: Date | string | null;
};

/**
 * Created-at boundary for shedding the label. Exported so the server can push
 * it into SQL against the indexed `User.createdAt` instead of testing rows in JS.
 */
export const newAccountCutoff = (now: Date = new Date()): Date =>
  new Date(now.getTime() - NEW_ACCOUNT_AGE_DAYS * MS_PER_DAY);

/** Negation of `buildNewAccountFilter`. Created exactly on the cutoff is NOT new. */
export const isNewAccount = (
  user: AccountLabelInput,
  now: Date = new Date()
): boolean => {
  if (user.verifiedHumanAt) return false;
  return new Date(user.createdAt).getTime() > newAccountCutoff(now).getTime();
};
